<template>
  <div id="customer-list">
    <div class="add-btn-box">
      <el-button type="primary" @click="addCustomer">新增客户</el-button>
    </div>
    <div
      class="alarm-table"
      v-loading="loading"
      element-loading-text="加载中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <el-table :data="tableList" style="width: 100%">
        <el-table-column prop="name" label="客户全称" align="center">
        </el-table-column>
        <el-table-column prop="statusCN" label="用户状态" align="center">
        </el-table-column>
        <el-table-column prop="shortName" label="简称" align="center">
        </el-table-column>
        <el-table-column label="所属大区" align="center">
          <template slot-scope="scope">
            {{regionFormat(scope.row.region)}}
          </template>
        </el-table-column>
        <el-table-column prop="code" label="代码" align="center">
        </el-table-column>
        <el-table-column prop="creatorName" label="创建人" align="center">
        </el-table-column>
        <el-table-column prop="managerName" label="负责人" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" width="240">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      background
      :current-page="pagination.currentPage"
      layout="prev, pager, next"
      :total="pagination.total"
      @current-change="pageChange"
    >
    </el-pagination>
    <!-- 弹窗新增编辑 -->
    <base-dialog
      :title='dialogTitle'
      size="big"
      :visible.sync="dialogTableVisibles"
      v-if="dialogTableVisibles"
      @close="resetForm('ruleForm')"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="80px"
        class="custom-ruleForm"
      >
        <el-form-item
          label="客户全称"
          prop="name"
          :rules="{
            required: true,
            message: '客户全称不能为空',
            trigger: 'blur',
          }"
        >
          <el-input :maxlength="20" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item
          label="客户简称"
          prop="shortName"
          :rules="{
            required: true,
            message: '客户简称不能为空',
            trigger: 'blur',
          }"
        >
          <el-input :maxlength="20" v-model="ruleForm.shortName"></el-input>
        </el-form-item>
        <el-form-item
          label="代码"
          prop="code"
          :rules="{ required: true, message: '代码不能为空', trigger: 'blur' }"
        >
          <el-input :maxlength="20" v-model="ruleForm.code"></el-input>
        </el-form-item>
        <el-form-item
          label="所属区域"
          prop="region"
          :rules="{
            required: true,
            message: '活动区域不能为空',
            trigger: 'change',
          }"
        >
          <el-select v-model="ruleForm.region" placeholder="请选择所属区域">
            <el-option
              v-for="item in areaList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="用户状态"
          prop="status"
          :rules="{
            required: true,
            message: '用户状态不能为空',
            trigger: 'change',
          }"
        >
          <el-select v-model="ruleForm.status" placeholder="请选择用户状态">
            <el-option
              v-for="item in customerStatus"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="创建人"
          prop="creator"
          :rules="{
            required: true,
            message: '创建人不能为空',
            trigger: 'change',
          }"
        >
          <el-select v-model="ruleForm.creator" placeholder="请选择创建人">
            <el-option
              v-for="item in userList"
              :key="item.value"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="负责人"
          prop="creator"
          :rules="{
            required: true,
            message: '负责人不能为空',
            trigger: 'change',
          }"
        >
          <el-select v-model="ruleForm.manager" placeholder="请选择负责人">
            <el-option
              v-for="item in userList"
              :key="item.value"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="使用时间"
          prop="useTime"
        >
          <el-date-picker
            v-model="ruleForm.useTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            @change="useTimeChange"
            placeholder="选择使用时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item class="handle">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >保存</el-button
          >
          <el-button @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </base-dialog>
  </div>
</template>

<script>
import BaseDialog from '@/components/BaseDialog.vue'
import { timestampFormat } from '@/utils/timestampFormat'
import {
  getCustomerslist,
  deleteCustomer,
  saveCustomer,
  getlistDictByType,
  customerDetail,
  updateCustomer,
} from './service'
export default {
  name: 'CustomerList',
  components: {
    BaseDialog,
  },
  data () {
    return {
      dialogTitle: '',
      dialogTableVisibles: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      dialogState: 'add',
      loading: false,
      tableList: [],
      customerId: '', // 当前客户id
      areaList: [],
      ruleForm: {
        name: '',
        shortName: '',
        code: '',
        region: '',
        status: '',
        creator: '',
        manager: '',
        useTime: '',
      },
      // 客户状态
      customerStatus: [],
      userList: [],
    }
  },
  computed: {},
  mounted () {
    // 获取客户列表
    this.getCustomers()
  },
  created () {
    // 获取客户状态
    this.getCustomerStatusByType()
    // 获取区域列表
    this.getlistDictType()
    // 获取人员信息（创建人、负责人通用）
    this.getUsersList()
  },
  methods: {
    // 大区格式化
    regionFormat (value) {
      let name = ''
      this.areaList.map(k => {
        if (k.value === value) {
          name = k.name
        }
      })
      return name
    },
    // 使用时间change事件
    useTimeChange (e) {
      console.log(e)
    },
    // 编辑客户
    handleEdit (index, row) {
      this.customerId = row.id
      this.getcustomerDetail(row.id)
      this.dialogState = 'edit'
      this.dialogTitle = '编辑'
    },
    // 删除客户
    handleDelete (index, row) {
      this.$confirm('确定删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await deleteCustomer(row.id)
          if (res.code === 0) {
            this.$message.success({ message: '操作成功', duration: 1500 })
            this.pagination.currentPage = 1
            this.getCustomers()
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    // 新建用户弹窗关闭
    resetForm (formName) {
      this.ruleForm.name = ''
      this.ruleForm.shortName = ''
      this.ruleForm.code = ''
      this.ruleForm.region = ''
      this.ruleForm.status = ''
      this.ruleForm.creator = ''
      this.ruleForm.manager = ''
      this.ruleForm.useTime = ''
      this.$refs.ruleForm.clearValidate()
      this.dialogTableVisibles = false
    },
    // 新增客户事件
    addCustomer () {
      this.dialogState = 'add'
      this.dialogTableVisibles = true
      // this.resetForm('ruleForm')
      this.dialogTitle = '新增'
    },
    /**
     * @description:   分页改变事件
     * @param {Number} currPage  当前页码
     * @return {*}
     */
    pageChange (currPage) {
      this.pagination.currentPage = currPage
      this.getCustomers()
    },
    // 获取客户详情
    async getcustomerDetail (id) {
      const res = await customerDetail(id)
      this.dialogTableVisibles = true
      let data = res.data
      data.creator = data.creatorName
      data.manager = data.managerName
      data.useTime = timestampFormat('YYYY-mm-dd HH:MM:SS', new Date(data.useTime))
      this.ruleForm = data
    },
    // 获取客户列表分页
    async getCustomers () {
      const params = {
        pageNo: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      }
      const res = await getCustomerslist(params)
      let data = res.data.list
      data.map(item => {
        let status = this.customerStatus.find(k => {
          return k.value === item.status
        })
        if (status) {
          item.statusCN = status.name
        } else {
          item.statusCN = ''
        }
      })
      this.tableList = data
      this.pagination.total = Number(res.data.total)
    },
    // 获取大区列表
    async getlistDictType () {
      const params = {
        type: 1,
      }
      const res = await getlistDictByType(params)
      this.areaList = res.data
    },
    // 获取客户状态
    async getCustomerStatusByType () {
      let params = {
        type: 'customer_type',
      }
      const res = await getlistDictByType(params)
      if (res.code === 0) {
        this.customerStatus = res.data
      } else {
        this.$message({
          message: res.msg,
          type: 'error',
        })
      }
    },
    // 获取人员信息（创建人、负责人通用）
    async getUsersList () {
      let params = {
        type: 'staff',
      }
      const res = await getlistDictByType(params)
      if (res.code === 0) {
        this.userList = res.data
      } else {
        this.$message({
          message: res.msg,
          type: 'error',
        })
      }
    },
    // 新建客户
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogState === 'add') {
            this.saveCus()
          } else {
            this.updateCus()
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 保存客户信息
    async saveCus () {
      const params = {
        name: this.ruleForm.name,
        shortName: this.ruleForm.shortName,
        code: this.ruleForm.code,
        region: this.ruleForm.region,
        status: this.ruleForm.status,
        creator: this.ruleForm.creator,
        manager: this.ruleForm.manager,
        useTime: this.ruleForm.useTime,
      }
      const res = await saveCustomer(params)
      if (res.code === 0) {
        this.$message.success({ message: '操作成功', duration: 1000 })
        this.dialogTableVisibles = false
        this.getCustomers()
        this.resetForm()
      } else {
        this.$message.error({ message: res.msg })
        // this.dialogTableVisibles = false
      }
    },
    // 更新客户信息
    async updateCus () {
      const params = {
        name: this.ruleForm.name,
        shortName: this.ruleForm.shortName,
        code: this.ruleForm.code,
        region: this.ruleForm.region,
        status: this.ruleForm.status,
        creator: this.ruleForm.creator,
        manager: this.ruleForm.manager,
        useTime: this.ruleForm.useTime,
        id: this.customerId,
      }
      const res = await updateCustomer(params)
      if (res.code === 0) {
        this.$message.success({ message: '操作成功', duration: 1000 })
        this.dialogTableVisibles = false
        this.getCustomers()
      } else {
        this.$message.error({ message: res.msg })
        // this.dialogTableVisibles = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
#customer-list {
  position: relative;
  .alarm-table {
    margin-top: 60px;
  }
  .add-btn-box {
    position: absolute;
    right: 60px;
    top: -38px;
    z-index: 1;
  }
  .custom-ruleForm {
    margin: 15px 50px;
  }
  .handle {
    position: absolute;
    right: 20px;
    bottom: 0;
  }
}
</style>
